/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_External_Dirs_TitleInputs */

const es_walkthrough_settings_external_dirs_title = /** @type {(inputs: Walkthrough_Settings_External_Dirs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas Externas`)
};

const en_walkthrough_settings_external_dirs_title = /** @type {(inputs: Walkthrough_Settings_External_Dirs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Folders`)
};

/**
* | output |
* | --- |
* | "External Folders" |
*
* @param {Walkthrough_Settings_External_Dirs_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_external_dirs_title = /** @type {((inputs?: Walkthrough_Settings_External_Dirs_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_External_Dirs_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_external_dirs_title(inputs)
	return en_walkthrough_settings_external_dirs_title(inputs)
});
export { walkthrough_settings_external_dirs_title as "walkthrough.settings_external_dirs_title" }